<template>
  <div>
    <mu-flexbox v-if="isLoading" justify="center center" align="center center" style="height: 316px;">
      <mu-flexbox-item align="center">
        <mu-circular-progress :size="46"></mu-circular-progress>
        <br/>
        <span v-text="$t('message.loadingText')"></span>
      </mu-flexbox-item>
    </mu-flexbox>
    <div v-if="!isLoading">
      <mu-card-header titleClass="boldTitle largeTitle" :title="title" :subTitle="subTitle"></mu-card-header>
      <mu-list-item :title="$t('message.privacyPreferencesQuestions')" @click="model.questions = !model.questions">
        <div slot="default">{{ $t('message.privacyPreferencesQuestionsExplain') }}</div>
        <mu-switch v-model="model.questions" slot="right"/>
      </mu-list-item>
      <mu-list-item :title="$t('message.privacyPreferencesFood')" @click="model.food = !model.food">
        <div slot="default">{{ $t('message.privacyPreferencesFoodExplain') }}</div>
        <mu-switch v-model="model.food" slot="right"/>
      </mu-list-item>
      <mu-list-item :title="$t('message.privacyPreferencesProgress')" @click="model.progress = !model.progress">
        <div slot="default">{{ $t('message.privacyPreferencesProgressExplain') }}</div>
        <mu-switch v-model="model.progress" slot="right"/>
      </mu-list-item>
      <mu-list-item :title="$t('message.privacyPreferencesAbout')" @click="model.information = !model.information">
        <div slot="default">{{ $t('message.privacyPreferencesAboutExplain') }}</div>
        <mu-switch v-model="model.information" slot="right"/>
      </mu-list-item>
      <mu-card-text>
        <mu-raised-button
          class="large"
          :disabled="isSaving"
          @click.native="submitForm()"
          :label="isSaving ? $t('message.updatingText') : $t('message.updateText')"
          secondary
          fullWidth>
        </mu-raised-button>
      </mu-card-text>
    </div>
  </div>
</template>
<script>
  import SettingsApi from '../../api/Settings'
  export default {
    name: 'settings-privacy',
    data() {
      return {
        title: this.$t('message.privacyPreferencesTitle'),
        subTitle: this.$t('message.privacyPreferencesSubTitle'),
        isSaving: false,
        isLoading: true,
        model: {
          medication: false
        },
        snackbar: false
      }
    },
    mounted() {
      let self = this;
      self.$gtag.pageview('/settings/privacy');
      setTimeout(function () {
        SettingsApi.getPrivacySettings()
          .then(function (response) {
            self.model = response.data;
            self.isLoading = false;
          })
          .catch(function () {
            self.model = {};
            self.isLoading = false;
          })
      }.bind(self), 300)
    },
    methods: {
      submitForm() {
        let self = this;
        self.isSaving = true;
        SettingsApi.putPrivacySettings(self.model)
          .then(function (response) {
            self.$toastr.success("Updated privacy");
            self.isSaving = false;
          })
          .catch(function (error) {
            self.isSaving = false;
          })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Privacy.vue?1d8da955